import React from "react";
import { EVENTS } from "@/lib/initiatives";
import { Link } from "react-router-dom";
import { Calendar, ArrowRight } from "lucide-react";

export default function Events() {
  return (
    <>
      <section className="section-py">
        <div className="mx-auto max-w-5xl container-x">
          <div className="text-xs uppercase tracking-[0.24em] text-[#4A5568]">Events & Recognition</div>
          <h1 className="mt-3 font-serif-display text-4xl md:text-6xl text-[#0A2540] leading-[1.05]">
            Celebrating women who lead our neighbourhoods.
          </h1>
          <p className="mt-6 text-lg text-[#4A5568] max-w-2xl">
            UB Maitreya Foundation runs a recurring "Felicitating Women Power in
            Governance" programme — honouring elected women representatives across
            India for their public service.
          </p>
        </div>
      </section>

      <section className="section-py bg-white border-y border-[#0A2540]/10">
        <div className="mx-auto max-w-7xl container-x space-y-16 md:space-y-24">
          {EVENTS.map((ev, i) => (
            <article
              key={ev.slug}
              data-testid={`event-detail-${ev.slug}`}
              className={`grid md:grid-cols-12 gap-8 md:gap-12 items-center`}
            >
              <div className={`md:col-span-6 ${i % 2 === 1 ? "md:order-2" : ""}`}>
                <div className="rounded-3xl overflow-hidden border border-[#0A2540]/10">
                  <img
                    src={ev.image}
                    alt={ev.title}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className={`md:col-span-6 ${i % 2 === 1 ? "md:order-1" : ""}`}>
                <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.24em] text-[#D4AF37]">
                  <Calendar className="w-3.5 h-3.5" /> {ev.theme}
                </div>
                <h2 className="mt-3 font-serif-display text-3xl md:text-4xl text-[#0A2540] leading-tight">
                  {ev.title}
                </h2>
                <div className="mt-2 text-[#4A5568]">{ev.subtitle}</div>
                <p className="mt-5 text-[#1A1A1A] leading-relaxed">{ev.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="section-py">
        <div className="mx-auto max-w-4xl container-x text-center">
          <h3 className="font-serif-display text-2xl md:text-4xl text-[#0A2540]">
            Nominate a woman leader from your community.
          </h3>
          <p className="mt-4 text-[#4A5568]">
            Know a Corporator, Sarpanch or Panchayat member whose work should be
            celebrated? Reach out — we'd love to feature them next.
          </p>
          <div className="mt-8">
            <Link
              to="/contact"
              data-testid="events-contact-cta"
              className="inline-flex items-center gap-2 rounded-full bg-[#0A2540] text-white px-8 py-3.5 font-medium hover:bg-[#D4AF37] hover:text-[#0A2540] transition-colors"
            >
              Contact the foundation <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
